export type AbsenceDto = {
  id: number;
  acti_user: number;
  acti_type?: number;
  acti_colour_fg?: string;
  acti_colour_bg?: string;
  acti_date: string;
  acti_start_time: string | null;
  acti_end_time: string | null;
  acti_tentative?: boolean;
  all_day: boolean;
  acab_approved_manager?: boolean | null;
  acab_approved_hr?: boolean | null;
  acab_notes?: string;
  acab_export?: boolean;
  block_position: string;
  workday_count?: number;
  show_workday_count?: boolean;
};

export type Absence = {
  id: number;
  userId: number;
  typeId?: number;
  colourFg?: string;
  colourBg?: string;
  useNeutralColour?: boolean;
  date: Date;
  dateStr: string;
  startTime: string | null;
  endTime: string | null;
  absenceTentative?: boolean;
  allDay: boolean;
  approvedManager?: boolean | null;
  approvedHr?: boolean | null;
  notes?: string;
  export?: boolean;
  blockPosition: string;
  workdays?: number;
  showWorkdays?: boolean;
};

export interface SelectedAbsence {
  userId: number;
  start: string;
  end: string;
  startTime: string | null;
  endTime: string | null;
  absenceIds: number[];
  primaryAbsenceId?: number;
  typeId?: number | null;
  absenceTentative?: boolean;
  approvedManager?: boolean | null;
  approvedHr?: boolean | null;
  notes?: string;
  snapshotAbsences?: Absence[];
  isMultiEvent?: boolean;
}

export type AbsenceLockDto = {
  target_user: number;
  owner_user: number;
  owner_name: string;
  expires_at: string;
  heartbeat_interval_seconds: number;
  ttl_seconds: number;
};

export type AbsenceLock = {
  userId: number;
  ownerUserId: number;
  ownerName: string;
  expiresAt: string;
  heartbeatIntervalSeconds: number;
  ttlSeconds: number;
};

export const ABSENCE_LOCK_STATUS = {
  IDLE: 'idle',
  ACQUIRING: 'acquiring',
  LOCKED: 'locked',
  CONFLICTED: 'conflicted',
  REFRESHING: 'refreshing',
  EXPIRED: 'expired',
} as const;

export type AbsenceLockStatus =
  (typeof ABSENCE_LOCK_STATUS)[keyof typeof ABSENCE_LOCK_STATUS];

export const ABSENCE_LOCK_ERROR_STATUSES = [
  ABSENCE_LOCK_STATUS.CONFLICTED,
  ABSENCE_LOCK_STATUS.EXPIRED,
] as const;

export function isAbsenceLockErrorStatus(status: AbsenceLockStatus) {
  return ABSENCE_LOCK_ERROR_STATUSES.includes(
    status as (typeof ABSENCE_LOCK_ERROR_STATUSES)[number],
  );
}

export function isAbsenceLockHeldStatus(status: AbsenceLockStatus) {
  return status === ABSENCE_LOCK_STATUS.LOCKED;
}

export type AbsenceLockState = {
  status: AbsenceLockStatus;
  lock: AbsenceLock | null;
  message: string | null;
};

export type AbsenceTypeDto = {
  id: number;
  acty_name: string;
  acty_group: number | null;
  acty_tentativeable: boolean;
  acty_approvable_manager: boolean;
  acty_approvable_hr: boolean;
  acty_backdateable: boolean;
};

export type AbsenceType = {
  id: number;
  name: string;
  groupId: number | null;
  tentativeable: boolean;
  approvableManager: boolean;
  approvableHr: boolean;
  backdateable: boolean;
};

export type ActivityTypeGroupDto = {
  id: number;
  actg_name: string;
  actg_colour_fg: string | null;
  actg_colour_bg: string | null;
};

export type ActivityTypeGroup = {
  id: number;
  name: string;
  colourFg: string | null;
  colourBg: string | null;
};

export type GroupStatDto = {
  group_id: number;
  group_name: string;
  colour_fg: string | null;
  colour_bg: string | null;
  used: number;
  available: number | null;
  warning: boolean;
  error: boolean;
};

export type GroupStat = {
  groupId: number;
  groupName: string;
  colourFg: string | null;
  colourBg: string | null;
  used: number;
  available: number | null;
  warning: boolean;
  error: boolean;
};
